export default __webpack_public_path__ + "static/media/smartphone-winset.0cb51e32.png";